import { render, staticRenderFns } from "./Closed.vue?vue&type=template&id=2e8e5991&scoped=true&"
import script from "./Closed.vue?vue&type=script&lang=ts&"
export * from "./Closed.vue?vue&type=script&lang=ts&"
import style0 from "./Closed.vue?vue&type=style&index=0&id=2e8e5991&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8e5991",
  null
  
)

export default component.exports